import { render, staticRenderFns } from "./pls_excel_fabu.vue?vue&type=template&id=f9735c64&scoped=true"
import script from "./pls_excel_fabu.vue?vue&type=script&lang=js"
export * from "./pls_excel_fabu.vue?vue&type=script&lang=js"
import style0 from "./pls_excel_fabu.vue?vue&type=style&index=0&id=f9735c64&prod&lang=scss"
import style1 from "./pls_excel_fabu.vue?vue&type=style&index=1&id=f9735c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9735c64",
  null
  
)

export default component.exports